const APPLICATION_LOCALES = [
  "de-de",
  "en-us",
  "es-es",
  "fr-fr",
  "ja-jp",
  "ko-kr",
  "zh-tw"
];

export default new class Locale {
  getLocale() {
    const regex = /^\/([a-z]{2}-[a-z]{2})?\//;
    const pathName = window.location.pathname;
    const matchedString = pathName.match(regex);
    if (APPLICATION_LOCALES.includes(matchedString[1])) {
      return matchedString[1];
    }

    return undefined;
  }
}();
